module.exports = __webpack_public_path__ + "static/media/icon_fd_u91.d45c80bc.png";